var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "Subheader",
        {
          attrs: {
            title: "Approval Level System Default Configurations",
            search: "Approval Levels",
          },
          model: {
            value: _vm.approvalSearch,
            callback: function ($$v) {
              _vm.approvalSearch = $$v
            },
            expression: "approvalSearch",
          },
        },
        [
          !_vm.readonly
            ? _c(
                "v-btn",
                {
                  attrs: { color: "add" },
                  on: { click: _vm.addApprovalLevel },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
                  _vm._v("\n      " + _vm._s(_vm.$t("Button.Add")) + "\n    "),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c(
            "v-alert",
            {
              attrs: { outline: "", color: "info", value: true, icon: "info" },
            },
            [
              _vm._v(
                "\n      Configure system-wide default approval levels configurations. Tenant configurations take presidence over Default configurations. Default configurations are used when Tenant configuration values are not present. For more information on how configurations work, see tenant configuration table information header.\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              items: _vm.systemDefaultApprovalLevelConfigurations,
              pagination: _vm.pagination,
              search: _vm.approvalSearch,
              loading: _vm.isLoading,
            },
            on: {
              "update:pagination": function ($event) {
                _vm.pagination = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "items",
                fn: function (props) {
                  return [
                    _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(
                        _vm._s(
                          props.item.MappedValue
                            ? props.item.MappedValue
                            : _vm.$t("ContinuousApprovalLevelManage.default")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(_vm._s(props.item.OutputText)),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(_vm._s(props.item.OutputDescription)),
                    ]),
                    _vm._v(" "),
                    !_vm.readonly
                      ? _c(
                          "td",
                          { staticClass: "text-xs-left" },
                          [
                            _c(
                              "EditButton",
                              {
                                attrs: { small: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.updateApprovalLevel(props.item)
                                  },
                                },
                              },
                              [_vm._v("Edit")]
                            ),
                            _vm._v(" "),
                            _c(
                              "DeleteButton",
                              {
                                attrs: {
                                  small: "",
                                  loading: _vm.isBeingDeleted(props.item),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteApprovalLevel(props.item)
                                  },
                                },
                              },
                              [_vm._v("Delete")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("UpsertApprovalLevelForm", {
        attrs: {
          approvalLevelConfiguration: _vm.approvalLevelConfigurationToUpdate,
          continuousDatabaseType: _vm.continuousDatabaseType,
          "system-default": "",
        },
        model: {
          value: _vm.upsertApprovalLevelFormModal,
          callback: function ($$v) {
            _vm.upsertApprovalLevelFormModal = $$v
          },
          expression: "upsertApprovalLevelFormModal",
        },
      }),
      _vm._v(" "),
      _c("ConfirmationDialog2", { ref: "confirmationDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }